import React from 'react';

const Education = () => {
    return (
        <section className="panel" id="education">
            <h2 className="panel-heading">Education</h2>
            <div className="panel-content">
                <div className="content-card">
                    <div className="entry-header">
                        <span className="entry-title">B.Sc. Computer Science - BITS Pilani</span>
                        <span className="badge">Current</span>
                    </div>
                    <div className="entry-meta">
                        <span>2023–2027</span>
                        <span>·</span>
                        <span>via Scaler School of Technology</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Education;
